import React, { Component, Fragment } from 'react';
import ReAnimation from '../../components/ReAnimation/ReAnimation';

import AppActions from '../../lib/flux/AppActions'
import AppActionTypes from '../../lib/flux/AppActionTypes'
import AppStore from '../../lib/flux/AppStore';

import { TweenLite } from 'gsap';

import './Theme.scss'

class Theme extends Component {
    constructor(props) {
        super(props);
        this.state = {
            animation: AppStore.getAnimations().theme
        }
    }

    componentDidMount() {
        AppStore.on(AppActionTypes.ANIMATION, this._handleStoreAnimationChange);
    }

    componentWillUnmount() {
        AppStore.removeListener(AppActionTypes.ANIMATION, this._handleStoreAnimationChange);
    }

    _handleStoreAnimationChange = ({ theme }) => {
        // console.log('_handleStoreAnimationChange', { theme });
        this.setState({ animation: theme });

        if (theme==true) {
            this.fadeIn()
        }

        
    }

    fadeIn = () => {
        TweenLite.set(this.refs.self,{opacity: 0});
        TweenLite.to(this.refs.self,1,{opacity: 1, ease: 'easeInOutQuart'})
    }
    build = () => {
        if (!this.state.animation) {
            return (
                <ReAnimation animation={true} done={() => { AppActions.animation({ theme: true }) }} />
            );
        }

        return (
            <div className="Theme" ref="self">
                <div className={'theme-text-container'}>
                    We are living in trying times — yearning for truth, knowledge, peace of mind and a path forward. 
                    Hope rests in our ability to understand, change and begin anew. And the power of ideas inspires us to recalibrate adversity into prosperity. 
                    <br /><br />
                    Year 9 is committed to connecting the <span>dots</span> so that we all may better embrace our civic responsibilities, communities, one another — even our own selves. Together, we will reimagine our future.

                </div>
                <div className={'theme-link-container'}>
                    <div className={'theme-link'} onClick={() => { AppActions.navigation({ location: 'lineup' }) }}>{'View Lineup'}</div>
                    <div className={'theme-link'} onClick={() => { AppActions.navigation({ location: 'tickets' }) }}>{'Buy Tickets'}</div>
                </div>
            </div>
        )
    }

    render() {
        return (
            <div className={'theme-container'}>
                {this.build()}
            </div>
        );
    }
}

export default Theme;